import { StyleSheet } from 'react-native'

const commonStyles = StyleSheet.create({
  flex: {
    flex: 1,
  },
  flexGrow: {
    flexGrow: 1,
  },
  overflowScroll: {
    overflow: 'scroll',
  },
  overflowHidden: {
    overflow: 'hidden',
  },
  fullWidth: {
    width: '100%',
  },
  fullHeight: {
    height: '100%',
  },
  fullSize: {
    width: '100%',
    height: '100%',
  },
  opacity90: {
    opacity: 0.9,
  },
  shadowText: {
    textShadowColor: 'rgba(0, 0, 0, 0.25)',
    textShadowOffset: { width: 0, height: 4 },
    textShadowRadius: 4,
  },
  placeholderContainer: {
    width: '90%',
    backgroundColor: '#fff',
    marginBottom: 24,
  },
  placeholder: {
    height: 8,
    marginTop: 6,
    justifyContent: 'center',
    backgroundColor: '#eeeeee',
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  spacedRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },
})

export default commonStyles
